import { TableCell, TableRow } from '@mui/material';
import type { FC } from 'react';

const NoChangesFound: FC = () => {
  return (
    <TableRow>
      <TableCell colSpan={3}>No Changes Found</TableCell>
    </TableRow>
  );
};

export default NoChangesFound;
